import moment from "moment"

export default {
    isToday(dateString, nowMoment) {
        return nowMoment.isSame(moment(dateString), "day");
    },
    isBetweenDate(dateString, startDateString, endDateString) {
        const sameOrAfter = moment(dateString).isSameOrAfter(moment(startDateString));
        const sameOrBefore = moment(dateString).isSameOrBefore(moment(endDateString));
        return sameOrAfter && sameOrBefore;
    },
    checkDate(dateString, todayMoment) {
        //Return -1 for history
        //Return 0 for today
        //Return 1 for upcoming
        const result = moment(moment(dateString).format("YYYY-MM-DD")).diff(todayMoment, 'days');
        return result;
    },
    canCancel(canCancelStatus, bookingEndTimeString, bookingTimeslotInMinutes, nowMoment) {
        const bookingEndTime = moment(bookingEndTimeString);
        const cancellatioEndTime = bookingEndTime.subtract(bookingTimeslotInMinutes, "minutes")
        const canCancel = canCancelStatus && nowMoment < cancellatioEndTime;
        // console.debug("canCancel", canCancel, bookingEndTimeString, cancellatioEndTime.format())

        return canCancel;
    },
    canCancelVisit(canCancelStatus, bookingStartTimeString, nowMoment) {
        const bookingStartTime = moment(bookingStartTimeString);
        const canCancel = canCancelStatus && nowMoment < bookingStartTime;

        return canCancel;
    },
    canCheckIn(canCheckInStatus, bookingStartTimeString, checkInStartTimeInMinutes, checkInEndTimeInMinutes, nowMoment) {
        const checkInStartTime = moment(bookingStartTimeString).subtract(checkInStartTimeInMinutes, "minutes")
        const checkInEndTime = moment(bookingStartTimeString).add(checkInEndTimeInMinutes, "minutes")
        const canCheckIn = canCheckInStatus && nowMoment >= checkInStartTime && nowMoment < checkInEndTime
        // console.debug("canCheckIn", canCheckIn, bookingStartTimeString, checkInStartTime.format(), checkInEndTime.format())

        return canCheckIn;
    },
    canExtend(canExtendStatus, bookingEndTimeString, extensionStartTimeInMinutes, extensionEndTimeInMinutes, nowMoment) {
        const extensionStartTime = moment(bookingEndTimeString).subtract(extensionStartTimeInMinutes, "minutes")
        const extensionEndTime = moment(bookingEndTimeString).subtract(extensionEndTimeInMinutes, "minutes")
        const canExtend = canExtendStatus && nowMoment >= extensionStartTime && nowMoment < extensionEndTime;
        // console.debug("canExtend", canExtend, bookingEndTimeString, extensionStartTime.format(), extensionEndTime.format())

        return canExtend;
    },
    isOnOpeningDaysOfWeek(dateString, openingDaysOfWeek) {
        if (!openingDaysOfWeek) {
            return true;
        }

        const dateMoment = moment(dateString);
        return openingDaysOfWeek.includes(dateMoment.day());
    },
    isHoliday(dateString, holidays, branchCode) {
        const isHoliday = holidays.some(x => this.isBetweenDate(dateString, x.startTime, x.endTime) &&
            !x.excludedBranches.includes(branchCode));

        return isHoliday;
    },
    isBranchOpenToday(dateString, openingDaysOfWeek, holidays, branchCode) {
        return this.isOnOpeningDaysOfWeek(dateString, openingDaysOfWeek) && !this.isHoliday(dateString, holidays, branchCode);
    }
}
